var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLinksTrainedIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219.041,
    height: 93.792,
    viewBox: "0 0 219.041 93.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161736",
    "data-name": "Group 161736",
    transform: "translate(-644.211 -482.191)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83703",
    "data-name": "Path 83703",
    d: "M256.859,65a9.181,9.181,0,0,1,0,18.363H204.395a9.181,9.181,0,1,1,0,18.363H233.25a9.181,9.181,0,1,1,0,18.363H219.906c-6.393,0-11.576,4.111-11.576,9.181q0,5.07,7.87,9.181a9.181,9.181,0,1,1,0,18.363H107.335a9.181,9.181,0,1,1,0-18.363H56.181a9.181,9.181,0,0,1,0-18.363h52.465a9.181,9.181,0,1,0,0-18.363H75.856a9.181,9.181,0,0,1,0-18.363h52.465a9.181,9.181,0,0,1,0-18.363Zm0,36.725a9.181,9.181,0,1,1-9.181,9.181A9.181,9.181,0,0,1,256.859,101.725Z",
    transform: "translate(597.211 417.191)",
    fill: "#f3f7ff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "link-circle-svgrepo-com",
    transform: "translate(708.211 484.164)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_83716",
    "data-name": "Path 83716",
    d: "M14.395,39.777a12.584,12.584,0,0,1-6.674-5.8,14.143,14.143,0,0,1,4.874-18.618L22.869,9a12.523,12.523,0,0,1,17.7,4.61,14.143,14.143,0,0,1-4.874,18.618l-1.361.966",
    transform: "translate(13.687 17.153)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83717",
    "data-name": "Path 83717",
    d: "M37.621,9.45a12.584,12.584,0,0,1,6.674,5.8,14.143,14.143,0,0,1-4.874,18.618L29.146,40.23a12.522,12.522,0,0,1-17.7-4.61A14.143,14.143,0,0,1,16.324,17l1.362-.966",
    transform: "translate(26.335 25.262)",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83718",
    "data-name": "Path 83718",
    d: "M45.909,89.819A43.909,43.909,0,1,0,2,45.909,43.91,43.91,0,0,0,45.909,89.819Z",
    fill: "none",
    stroke: "#1f64e7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLinksTrainedIcon);
export default __webpack_public_path__ + "static/media/no-links-trained-icon.fc63fffd1c26f992df946a9dbd110bb9.svg";
export { ForwardRef as ReactComponent };